function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "calendar-icon");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "#45c7f3",
  width: 45.41,
  height: 40.22,
  rx: 3.64
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M33.67,9.11H30.84v1.74a1.82,1.82,0,1,1-3.64,0V9.11h-8v1.74a1.82,1.82,0,1,1-3.64,0V9.11H12.84a2.33,2.33,0,0,0-2.32,2.32v1.45a.89.89,0,0,0,.87.86H35.12a.89.89,0,0,0,.87-.86V11.43A2.33,2.33,0,0,0,33.67,9.11Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M35.12,16.64H11.39a.89.89,0,0,0-.87.87V31.68A2.33,2.33,0,0,0,12.84,34H33.67A2.32,2.32,0,0,0,36,31.68V17.51A.89.89,0,0,0,35.12,16.64ZM33.6,30.49a1.88,1.88,0,0,1-1.88,1.88H14.79a1.88,1.88,0,0,1-1.88-1.88V19a.73.73,0,0,1,.71-.71H32.9a.72.72,0,0,1,.7.71Z"
})), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 16.13,
  y: 6.16,
  width: 2.66,
  height: 5.56,
  rx: 1.33
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 27.74,
  y: 6.16,
  width: 2.66,
  height: 5.56,
  rx: 1.33
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 16.21,
  y: 20.73,
  width: 3.69,
  height: 3.69
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 21.55,
  y: 20.73,
  width: 3.69,
  height: 3.69
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 26.95,
  y: 20.73,
  width: 3.69,
  height: 3.69
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 16.21,
  y: 26.21,
  width: 3.69,
  height: 3.69
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 21.55,
  y: 26.21,
  width: 3.69,
  height: 3.69
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 26.95,
  y: 26.21,
  width: 3.69,
  height: 3.69
}))));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45.41,
    height: 40.22,
    viewBox: "0 0 45.41 40.22"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/calendar-icon.df093c05.svg";
export { SvgComponent as ReactComponent };